import React from 'react'
import { COLORS } from 'utils'

import { IconStyles } from '../types'
import { LinkCustom } from './styles'

interface LinkProps extends IconStyles {
  onClick?: any
}

export const LinkIcon: React.FC<LinkProps> = ({
  disabled,
  onClick,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  colorIcon
}) => {
  return (
    <LinkCustom
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={disabled ? 'default' : cursor}
      onClick={disabled ? () => null : onClick}
      colorIcon={disabled ? COLORS.gray : colorIcon}
    />
  )
}
